import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAHniGeBbya_fpp6OurXZLyRvq_W6NbJjo",
  authDomain: "classcare-442b7.firebaseapp.com",
  projectId: "classcare-442b7",
  storageBucket: "classcare-442b7.firebasestorage.app",
  messagingSenderId: "540521717913",
  appId: "1:540521717913:web:aa0558803650b111f8d808",
  measurementId: "G-JKV3JHQKEJ"
};

const app = initializeApp(firebaseConfig);
export { app as firebaseApp };
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
